
const authentication = require('react-azure-adb2c2').default;

export const detail = (values: any) => {

    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/api/v1/rent/response/contract/docs/detail/` + values
    // const url = `http://localhost:5000/api/v1/rent/response/contract/docs/detail/` + values
    const token = authentication.getAccessToken();
    //const search = values ? values : {};
    // alert(url)

    return fetch(url, {
        method: 'get',
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    })
        .then(res => res.json())
        .then(payloaddetail => ({ payloaddetail }))
        .catch(errordetail => ({ errordetail }));

}

export const update = (values: any) => {


    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/api/v1/rent/response/contract/docs/update/` + values.fileid
    // const url = `http://localhost:5000/api/v1/rent/response/contract/docs/update/` + values.fileid

    const token = authentication.getAccessToken();
    //const search = values ? values : {};

    // alert(JSON.stringify(values))
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

}

export const deletefile = (values: any) => {

    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/api/v1/rent/response/contract/docs/delete/` + values
    // const url = `http://localhost:5000/api/v1/rent/response/contract/docs/delete/` + values

    const token = authentication.getAccessToken();
    //const search = values ? values : {};

    // alert(JSON.stringify(values))
    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

}


export const download = (values: any) => {


    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/api/v1/rent/response/contract/docs/download/` + values
    // const url = `http://localhost:5000/api/v1/rent/response/contract/docs/download/` + values


    // let url = `https://localhost:44341/api/RentContractAccounting`;

    const token = authentication.getAccessToken();




    // alert(JSON.stringify(accountinglistset))
    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(accountinglistset),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(response => response.blob())
        .then(payload => ({ payload }))
        // .then(res => res.json())
        // .then(payload => ({ payload }))
        .catch(error => ({ error }));


};



export const upload = (values: any) => {


    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/api/v1/rent/response/contract/docs/uploadfile/`
    // const url = `http://localhost:5000/api/v1/rent/response/contract/docs/uploadfile/`


    // let url = `https://localhost:44341/api/RentContractAccounting`;

    const token = authentication.getAccessToken();


    // alert(url)
    var formData = new FormData();
    formData.append("files", values.file[0]);
    formData.append("rent_response_id", values.response_id);
    formData.append("remarks", values.remarks);
    formData.append("contractdoc1", values.contractdoc1);
    formData.append("contractdoc2", values.contractdoc2);
    formData.append("contractdoc3", values.contractdoc3);
    formData.append("contractdoc4", values.contractdoc4);
    formData.append("contractdoc5", values.contractdoc5);
    formData.append("contractdoc6", values.contractdoc6);
    console.log(formData)
    // alert(JSON.stringify(accountinglistset))
    return fetch(url, {
        method: 'post',
        body: formData,

        headers: { 'Authorization': 'Bearer ' + token },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        // .then(res => res.json())
        // .then(payload => ({ payload }))
        .catch(error => ({ error }));


};